import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api';

Vue.use(VueCompositionApi);

import VueResource from 'vue-resource';

Vue.use(VueResource);

import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';

import i18n from './i18n'

//Import Froala Editor 
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/third_party/image_tui.min.css';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import VueFroala from 'vue-froala-wysiwyg'; 
Vue.use(VueFroala);

import {portalAddress, serverAddress} from "./feathers-client";

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['canvas-datagrid'];

Vue.use({
    install(Vue) {
        //Event Bus
        Vue.prototype.$eventHub = new Vue();

        Vue.prototype.$getFileURL = function (f) {
            if (f instanceof File) {
                return URL.createObjectURL(f);
            } else {
                return f.src;
            }
        };

        //FeatherJS error handling
        Vue.prototype.$handleFeatherError = function (e) {
            let errorMsg = e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;

            // custom HTTP uploadFile erorr handling
            if (!e.ok && e.body && e.body.error) {
                errorMsg = e.body.error;
            }

            this.$store.dispatch('showSnackBar', errorMsg);
        };

        // Upload File
        Vue.prototype.$uploadFile = async function (file) {
            let formData = new FormData();
            formData.append('file', file);

            const response = await this.$http.post(serverAddress + '/upload', formData, {
                headers: {
                    // 'Origin': portalAddress,
                    // 'Access-Control-Allow-Origin': portalAddress,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + this.$store.state.auth.accessToken,
                },
            });

            const json = await response.json();

            return json.id;

            // // console.log(await feathersClient.service('upload').create(formData))
            // const response = await fetch(serverAddress + '/upload', { // Your POST endpoint
            //     // const response = await fetch('http://23.99.115.243:3030/upload', { // Your POST endpoint
            //     method: 'POST',
            //     headers: {
            //         'Origin': portalAddress,
            //         'Access-Control-Allow-Origin': portalAddress,
            //         'X-Requested-With': 'XMLHttpRequest',
            //         'Authorization': 'Bearer ' + feathersClient.authentication.getAccessToken(),
            //     },
            //     body: formData // This is your file object
            // });

            // return response.json().id;
        };
    }
});


new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
